export const round = value => {
  return Math.round(value);
};

export const roundToTwoDecimal = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const nullish = val =>
  typeof val === 'undefined' || val === null || val === '' || val === ' ';

export const isEmpty = val =>
  typeof val === 'undefined' || val === null || val === '';

export const areSameIds = (a = [], b = []) => {
  if (a.length !== b.length) return false;

  const setA = new Set(a);
  for (const id of b) {
    if (!setA.has(id)) return false;
  }
  return true;
};
